import React from 'react'
import { ShelvesEdgeLabelling, ClearanceLabels, ClearanceLabelsList, SavedLabels, AccessDenied, ProductLookup, Home, ContentManagement } from './pages'
import PettyCash from './pages/pettyCash/pettyCash'
import Vendor from './pages/vendor/vendor'
import RFP from './pages/rfp/rfp'
import Chatbot from './pages/chatbot/chatbot'
import InventoryMovement from './pages/inventoryMovement/InventoryMovement'
import { withNavigationWatcher } from './context/navigationContext'
import { Navigate } from 'react-router-dom'

// HOC to check if user is Cognito and redirect if needed
const withCognitoCheck = (Component, requiresAuth, restrictedForCognito = false) => {
  return (props) => {
    const loginType = localStorage.getItem('loginType')

    // If the component is restricted for Cognito users and user is Cognito, redirect to access denied
    if (restrictedForCognito && loginType === 'cognito') {
      return <Navigate to="/accessDenied" replace />
    }

    return <Component {...props} />
  }
}

// Define all routes
const routes = [
  {
    path: '/shelfEdgeLabels',
    element: ShelvesEdgeLabelling
  },
  {
    path: '/clearanceLabels',
    element: ClearanceLabels
  },
  {
    path: '/viewClearanceLabels',
    element: ClearanceLabelsList
  },
  {
    path: '/savedShelfEdgeLabels',
    element: SavedLabels
  },
  {
    path: '/productLookup',
    element: ProductLookup
  },
  {
    path: '/accessDenied',
    element: AccessDenied
  },
  {
    path: '/home',
    element: Home
  },
  {
    path: '/',
    element: Home
  },
  {
    path: '/chatBot',
    element: Chatbot
  },
  {
    path: '/content-management',
    element: ContentManagement
  },
  {
    path: '/inventoryMovement',
    element: InventoryMovement,
    restrictedForCognito: true // Backend rejects Cognito tokens for inventoryMovement APIs
  },
  {
    path: '/pettyCash',
    element: PettyCash,
    restrictedForCognito: true // Mark this route as restricted for Cognito users
  },
  {
    path: '/rfp',
    element: RFP,
    restrictedForCognito: true // Mark this route as restricted for Cognito users
  },
  {
    path: '/vendor',
    element: Vendor,
    restrictedForCognito: true // Mark this route as restricted for Cognito users
  }
]

export default routes.map((route) => {
  return {
    ...route,
    element: withNavigationWatcher(
      withCognitoCheck(
        route.element,
        true,
        route.restrictedForCognito || false
      ),
      route.path
    )
  }
})
